import { render, staticRenderFns } from "./WaiterHomeView.vue?vue&type=template&id=7a6b8204&"
import script from "./WaiterHomeView.vue?vue&type=script&lang=ts&"
export * from "./WaiterHomeView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports